import { createSlice } from '@reduxjs/toolkit';
import RecipeModel from '../../components/model/RecipeModel';

const RecipeSlice = createSlice({
    name: 'recipe',
    initialState: RecipeModel,
    reducers: {
        setRecipeObj(state, { payload }) {
            state.recipeName = payload.recipeName;
            state.recipeText = payload.recipeText;
            state.uuid = payload.uuid;
            state.productsList = payload.productsList;
            state.id = payload.id;
            state.allProteinsLittleOnes = payload.allProteinsLittleOnes;
            state.allProteins = payload.allProteins;
            state.allFatLittleOnes = payload.allFatLittleOnes;
            state.allFat = payload.allFat;
            state.allEnergyValueKcalLittleOnes =
                payload.allEnergyValueKcalLittleOnes;
            state.allEnergyValueKcal = payload.allEnergyValueKcal;
            state.allCarbohydratesLittleOnes =
                payload.allCarbohydratesLittleOnes;
            state.allCarbohydrates = payload.allCarbohydrates;
        },
    },
});

export default RecipeSlice.reducer;
export const { setRecipeObj } = RecipeSlice.actions;
